export enum ENonConformiteType {
    AReception = 1,
    EnCoursdAnalyse = 2
}